@if (field) {
  <mat-form-field appearance="outline">
    <mat-label [attr.for]="field?.key">{{ field?.label }}</mat-label>
    <input
      matInput
      [name]="field?.key"
      [type]="field?.type || 'text'"
      [formControlName]="field?.key"
      [readonly]="field?.readonly || false"
      (blur)="onBlur()"
      />
      <!-- Required error -->
      @if (controlContainer.control?.get(field?.key)?.hasError('required')) {
        <mat-error
          >Debe completar el campo.
        </mat-error>
      }
      <!-- Max length error -->
      @if (controlContainer.control?.get(field?.key)?.hasError('maxlength')) {
        <mat-error
          >
          {{ field?.rules?.maxLength?.errorMessage }}
          {{ field?.rules?.maxLength?.value }}
        </mat-error>
      }
      <!-- Min length error -->
      @if (controlContainer.control?.get(field?.key)?.hasError('minlength')) {
        <mat-error
          >
          {{ field?.rules?.minLength?.errorMessage }}
          {{ field?.rules?.minLength?.value }}
        </mat-error>
      }
      @if (controlContainer.control?.get(field?.key)?.hasError('valueExists')) {
        <mat-error
          >
          {{ field?.rules?.valueExists?.errorMessage }}
        </mat-error>
      }
      <!-- Pattern error -->
      @if (controlContainer.control?.get(field?.key)?.hasError('pattern')) {
        <mat-error
          >
          {{ field?.rules?.pattern?.errorMessage }}
        </mat-error>
      }
      <app-custom-warning [customWarning]="customWarning"></app-custom-warning>
    </mat-form-field>
  }
